// Header
export const headerHeightSm = '56px';
export const headerHeightMd = '72px';
export const headerHeightLg = '80px';
